import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Trash2, RefreshCw } from "lucide-react";

export default function DemoDataAdmin() {
    const [status, setStatus] = useState(null);
    const [busy, setBusy] = useState(false);

    const load = () => api.get("/demo/status").then(({ data }) => setStatus(data));
    useEffect(() => { load(); }, []);

    const seed = async (reset = false) => {
        setBusy(true);
        try {
            const { data } = await api.post(`/demo/seed?reset=${reset ? "true" : "false"}`);
            toast.success(`Seeded ${data.count} demo project(s)`);
            load();
        } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
        setBusy(false);
    };

    const clear = async () => {
        if (!window.confirm("Delete all demo records for this org? Real records are untouched.")) return;
        setBusy(true);
        try {
            const { data } = await api.post("/demo/clear");
            toast.success(`Deleted ${data.deleted_count} demo record(s)`);
            load();
        } catch { toast.error("Failed"); }
        setBusy(false);
    };

    return (
        <div className="p-6 max-w-2xl" data-testid="demo-data-admin">
            <div className="mb-6">
                <div className="text-xs uppercase tracking-widest text-muted-foreground">Demonstration data</div>
                <h1 className="text-2xl tracking-tight mt-1">Sample projects</h1>
                <p className="text-sm text-muted-foreground mt-2">Populates your organization with six realistic sample projects (Fix &amp; Flip, Custom Home, Duplex, Land Development, Commercial, Tax-Deed Rehab) and demo investors/lender. Real records are never touched.</p>
            </div>

            <div className="border border-border p-6 space-y-4">
                <div className="flex items-center justify-between">
                    <div>
                        <div className="text-sm font-medium">Demo project count</div>
                        <div className="text-2xl tracking-tight mt-1" data-testid="demo-count">{status?.demo_project_count ?? "…"}</div>
                    </div>
                    <Sparkles size={32} className="text-amber-500 opacity-70" />
                </div>
                <div className="flex flex-wrap gap-2">
                    <button onClick={() => seed(false)} disabled={busy} className="bg-foreground text-background px-3 py-2 text-xs" data-testid="demo-seed-btn">
                        {busy ? "Working…" : (status?.demo_project_count ? "Refresh demo data" : "Seed 6 demo projects")}
                    </button>
                    <button onClick={() => seed(true)} disabled={busy} className="border border-border px-3 py-2 text-xs flex items-center gap-1" data-testid="demo-reset-btn">
                        <RefreshCw size={10} /> Reset & re-seed
                    </button>
                    {status?.demo_project_count > 0 && (
                        <button onClick={clear} disabled={busy} className="border border-red-500/40 text-red-600 px-3 py-2 text-xs flex items-center gap-1" data-testid="demo-clear-btn">
                            <Trash2 size={10} /> Clear demo data
                        </button>
                    )}
                </div>
            </div>

            <div className="mt-4 text-xs text-muted-foreground">
                Every demo record carries <code className="bg-secondary px-1">is_demo=true</code>. Demo projects are labeled with a persistent "Demonstration data" banner in the portal view.
            </div>
        </div>
    );
}
